'use client'

import { useEffect } from 'react'
import { setLastOpenedManageCommunityCookie } from './racing/actions/community'

export default function LastOpenedCommunityTracker({ communityId }) {
  useEffect(() => {
    setLastOpenedManageCommunityCookie(communityId)
  }, [communityId])

  return null
}
